module.exports = "../../static/img/UvazhenieLichnosti.37b3e1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_us_main/UvazhenieLichnosti.jpg
// module id = zZFf
// module chunks = 1